/** Serverzustand der Statusseite. */

import { useQuery } from '@tanstack/react-query';

import { fetchSystemStatus, fetchSystemVersion } from './api';

export const systemKeys = {
  version: ['system', 'version'] as const,
  status: ['system', 'status'] as const,
};

/**
 * Die Fassung unten in der Navigation.
 *
 * Sie aendert sich nur mit einer Auslieferung -- und danach laedt ohnehin
 * jeder die Seite neu, weil das Buendel ein anderes ist. Ein Abruf je
 * Sitzung genuegt.
 */
export function useSystemVersion(enabled: boolean) {
  return useQuery({
    queryKey: systemKeys.version,
    queryFn: fetchSystemVersion,
    enabled,
    staleTime: Infinity,
    retry: false,
  });
}

/**
 * Der Zustand -- jede Minute neu, solange die Seite offen ist.
 *
 * Eine Statusseite, die man offen liegen laesst, soll nicht den Stand vom
 * Aufrufen zeigen. Eine Minute ist so oft, wie sich Last und Dienste
 * sinnvoll aendern; oefter waere eine Abfrage, die nur sich selbst misst.
 */
export function useSystemStatus() {
  return useQuery({
    queryKey: systemKeys.status,
    queryFn: fetchSystemStatus,
    refetchInterval: 60_000,
  });
}
